import { useMemo } from 'react';
import type { State } from './types';
import { memoize } from '@/lib/memoize';

export function useComputed(state: State) {
  const peopleLookup = useMemo(() => memoize(state.data), [state.data]);

  return useMemo(
    () => ({
      peopleLookup,
    }),
    [peopleLookup],
  );
}

export type Computed = ReturnType<typeof useComputed>;
